import { withTheme } from 'styled-components'
import Layout from './Layout'

export default withTheme(Layout)
